/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyInsuranceWorkspaceCreateSchema } from '../models/CompanyInsuranceWorkspaceCreateSchema';
import type { CompanyInsuranceWorkspaceDetailSchema } from '../models/CompanyInsuranceWorkspaceDetailSchema';
import type { CompanyInsuranceWorkspaceListSchema } from '../models/CompanyInsuranceWorkspaceListSchema';
import type { CompanyInsuranceWorkspaceUpdateSchema } from '../models/CompanyInsuranceWorkspaceUpdateSchema';
import type { InsuranceCompanyContractCreateSchema } from '../models/InsuranceCompanyContractCreateSchema';
import type { InsuranceCompanyContractDetailSchema } from '../models/InsuranceCompanyContractDetailSchema';
import type { InsuranceCompanyContractUpdateSchema } from '../models/InsuranceCompanyContractUpdateSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompanyInsuranceWorkspacesApi {
    /**
     * Get Company Insurance Workspace List
     * Get company insurance workspace list. <br>Required permission: get_company_insurance_workspace_list
     * @returns CompanyInsuranceWorkspaceListSchema OK
     * @throws ApiError
     */
    public static insuranceGetCompanyInsuranceWorkspaceListGet({
        kBatchId,
    }: {
        kBatchId?: (string | null),
    }): CancelablePromise<Array<CompanyInsuranceWorkspaceListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company-insurance-workspaces/',
            query: {
                'k_batch_id': kBatchId,
            },
        });
    }
    /**
     * Create Company Insurance Workspace
     * Create company insurance workspace. <br>Required Permission: create_company_insurance_workspace
     * @returns CompanyInsuranceWorkspaceDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreateCompanyInsuranceWorkspacePost({
        requestBody,
    }: {
        requestBody: CompanyInsuranceWorkspaceCreateSchema,
    }): CancelablePromise<CompanyInsuranceWorkspaceDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company-insurance-workspaces/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Company Insurance Workspace Detail
     * Get company insurance workspace detail. <br>Required permission: get_company_insurance_workspace_detail
     * @returns CompanyInsuranceWorkspaceDetailSchema OK
     * @throws ApiError
     */
    public static insuranceGetCompanyInsuranceWorkspaceDetailGet({
        companyInsuranceWorkspaceId,
    }: {
        companyInsuranceWorkspaceId: string,
    }): CancelablePromise<CompanyInsuranceWorkspaceDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company-insurance-workspaces/{company_insurance_workspace_id}/',
            path: {
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
            },
        });
    }
    /**
     * Update Company Insurance Workspace
     * Update company insurance workspace. <br>Required Permission: update_company_insurance_workspace
     * @returns CompanyInsuranceWorkspaceDetailSchema OK
     * @throws ApiError
     */
    public static insuranceUpdateCompanyInsuranceWorkspacePut({
        companyInsuranceWorkspaceId,
        requestBody,
    }: {
        companyInsuranceWorkspaceId: string,
        requestBody: CompanyInsuranceWorkspaceUpdateSchema,
    }): CancelablePromise<CompanyInsuranceWorkspaceDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/company-insurance-workspaces/{company_insurance_workspace_id}/',
            path: {
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Company Insurance Workspace
     * Delete company insurance workspace. <br>Required Permission: delete_company_insurance_workspace
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeleteCompanyInsuranceWorkspaceDelete({
        companyInsuranceWorkspaceId,
    }: {
        companyInsuranceWorkspaceId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/company-insurance-workspaces/{company_insurance_workspace_id}/',
            path: {
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
            },
        });
    }
    /**
     * Update Company Insurance Workspace Sukl Tls Certificate
     * Replace the workspace SÚKL TLS certificate and its password. <br>Required Permission: update_company_insurance_workspace
     * @returns void
     * @throws ApiError
     */
    public static insuranceUpdateCompanyInsuranceWorkspaceSuklTlsCertificatePost({
        companyInsuranceWorkspaceId,
        formData,
    }: {
        companyInsuranceWorkspaceId: string,
        formData: {
            file: Blob;
            password: string;
        },
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company-insurance-workspaces/{company_insurance_workspace_id}/sukl-tls-certificate/',
            path: {
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Create Insurance Company Contract
     * Create insurance company contract. <br>Required Permission: create_insurance_company_contract
     * @returns InsuranceCompanyContractDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreateInsuranceCompanyContractPost({
        companyInsuranceWorkspaceId,
        requestBody,
    }: {
        companyInsuranceWorkspaceId: string,
        requestBody: InsuranceCompanyContractCreateSchema,
    }): CancelablePromise<InsuranceCompanyContractDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company-insurance-workspaces/{company_insurance_workspace_id}/insurance-company-contracts/',
            path: {
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Insurance Company Contract Detail
     * Get insurance company contract detail. <br>Required permission: get_insurance_company_contract_detail
     * @returns InsuranceCompanyContractDetailSchema OK
     * @throws ApiError
     */
    public static insuranceGetInsuranceCompanyContractDetailGet({
        companyInsuranceWorkspaceId,
        insuranceCompanyContractId,
    }: {
        companyInsuranceWorkspaceId: string,
        insuranceCompanyContractId: string,
    }): CancelablePromise<InsuranceCompanyContractDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company-insurance-workspaces/{company_insurance_workspace_id}/insurance-company-contracts/{insurance_company_contract_id}/',
            path: {
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
                'insurance_company_contract_id': insuranceCompanyContractId,
            },
        });
    }
    /**
     * Update Insurance Company Contract
     * Update insurance company contract. <br>Required Permission: update_insurance_company_contract
     * @returns InsuranceCompanyContractDetailSchema OK
     * @throws ApiError
     */
    public static insuranceUpdateInsuranceCompanyContractPut({
        companyInsuranceWorkspaceId,
        insuranceCompanyContractId,
        requestBody,
    }: {
        companyInsuranceWorkspaceId: string,
        insuranceCompanyContractId: string,
        requestBody: InsuranceCompanyContractUpdateSchema,
    }): CancelablePromise<InsuranceCompanyContractDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/company-insurance-workspaces/{company_insurance_workspace_id}/insurance-company-contracts/{insurance_company_contract_id}/',
            path: {
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
                'insurance_company_contract_id': insuranceCompanyContractId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Insurance Company Contract
     * Delete insurance company contract. <br>Required Permission: delete_insurance_company_contract
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeleteInsuranceCompanyContractDelete({
        companyInsuranceWorkspaceId,
        insuranceCompanyContractId,
    }: {
        companyInsuranceWorkspaceId: string,
        insuranceCompanyContractId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/company-insurance-workspaces/{company_insurance_workspace_id}/insurance-company-contracts/{insurance_company_contract_id}/',
            path: {
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
                'insurance_company_contract_id': insuranceCompanyContractId,
            },
        });
    }
}
